var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLargePodcastPage = function SvgLargePodcastPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.727 5.167h16.546a2.56 2.56 0 0 1 2.56 2.56v16.546a2.56 2.56 0 0 1-2.56 2.56H7.727a2.56 2.56 0 0 1-2.56-2.56V7.727a2.56 2.56 0 0 1 2.56-2.56M3 7.727A4.727 4.727 0 0 1 7.727 3h16.546A4.727 4.727 0 0 1 29 7.727v16.546A4.727 4.727 0 0 1 24.273 29H7.727A4.727 4.727 0 0 1 3 24.273zm10.722 2.28a2.28 2.28 0 1 1 4.558 0v5.971a2.28 2.28 0 1 1-4.558 0zM10.684 16v.004c0 2.652 1.98 4.846 4.557 5.211v1.556h-2.28v1.504h6.077V22.77h-2.277v-1.555c2.577-.365 4.559-2.56 4.559-5.212v-2.259h-1.519v2.255H19.8V16c0 2.077-1.7 3.76-3.799 3.76-2.098 0-3.798-1.683-3.798-3.76h.002v-2.256h-1.52v2.255z",
    clipRule: "evenodd"
  })));
};
export default SvgLargePodcastPage;